import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../app.json";
import StaffSideTag from "./partials/StaffSideTag";
import { Redirect, NavLink } from "react-router-dom";
import NavButton from "./partials/NavButton";
import PatientBasicList from "../Patient/partial/PatientBasicList";
import StaffCorrespondence from "./Correspondence/index.jsx";
import StaffRota from "./Rota/index.jsx";
import * as qs from "query-string";
import LoadingSpinner from "../../partials/loading";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { Staff, REVOKE_ADMIN, UPDATE_ADMIN, UPDATE_STAFF_GP, MAKE_TOP_STAFF, REVOKE_TOP_STAFF } from "../../queries/staff.query";
import { IS_SUPER_ADMIN } from "../../queries/super-admin-query";
import auth from "../../providers/Auth.Provider";
import NextOfKin from "./NextOfKin/index.jsx";
import GPComponent from "../GP/index.jsx";
import { toast } from "react-toastify";
import { CleanMessage } from "../../util/app";
import StaffLeave from "./Leave";

const Profile = ({ location }) => {
    const [activeStaff, setActive] = useState(null);
    const [isSuperAdmin, setSuperAdmin] = useState(false);
    const { ref } = qs.parse(location.search, {
        ignoreQueryPrefix: true,
    });

    const { loading } = useQuery(Staff.QUERY.GETSTAFF, {
        variables: { id: ref },
        onCompleted: (data) => {
            setActive(data.GetStaff.doc);
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });
    // Update GP
    const [updateGPFunc, { loading: gpLoading }] = useMutation(UPDATE_STAFF_GP, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.UpdateStaffGP;
            toast.success(message);
        },
    });

    const [activeContent, SetActiveContent] = useState({
        rota: true,
    });
    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const { admin, id } = GetToken() && GetAuthenticatedStaff();
    const [infoExpanded, SetInfoExpanded] = useState(false);

    // Update is super admin
    useQuery(IS_SUPER_ADMIN, {
        variables: {
            id,
        },
        onCompleted: (data) => {
            if (data.isSuperAdmin) {
                setSuperAdmin(data.isSuperAdmin);
            }
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });
    const title = activeStaff ? activeStaff.surname + " Profile" : "Staff Profile";

    // Grant Admin rights
    const [MakeAdminFunc, { loading: aLoading }] = useMutation(UPDATE_ADMIN, {
        onCompleted: (data) => toast.success(data.MakeAdmin.message),
        onError: (e) => toast.error(CleanMessage(e.message)),
    });
    // Revoke Admin Rights
    const [TakeawayAdminFunc, { loading: tLoading }] = useMutation(REVOKE_ADMIN, {
        onCompleted: (data) => toast.success(data.RevokeAdminRights.message),
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    const [makeTopFunc, { loading: topLoading }] = useMutation(MAKE_TOP_STAFF, {
        onCompleted: (data) => {
            const { message, doc } = data.MakeTopStaff;
            toast.success(message);
            setActive(doc);
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    const [revokeTopFunc, { loading: rLoading }] = useMutation(REVOKE_TOP_STAFF, {
        onCompleted: (data) => {
            const { message, doc } = data.RevokeTopStaff;
            toast.success(message);
            setActive(doc);
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });

    if (!ref) return <Redirect to="/home/staffing/list" />;

    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>
            </Helmet>

            <div className="row">
                <div className="col-12">
                    <LoadingSpinner loading={loading || gpLoading || topLoading || rLoading} bar={true} />
                </div>
                {!infoExpanded && (
                    <div className="col-lg-3 col-md-4 col-12 fade-in">
                        {/* Staff Basic Info */}
                        {activeStaff && <StaffSideTag staff={activeStaff} />}
                        <LoadingSpinner loading={gpLoading} bar={true} />
                        {activeStaff && (
                            <GPComponent
                                item={activeStaff.gp}
                                title="Staff GP Information"
                                onSubmit={async (model) => {
                                    await updateGPFunc({
                                        variables: {
                                            model,
                                            id: activeStaff.id,
                                        },
                                    });
                                }}
                            />
                        )}
                        {/* Staff Additional Info */}
                        {activeStaff && isSuperAdmin && (
                            <div className="card fade-in">
                                <div className="card-head">
                                    <header>Admin Status {activeStaff.admin && <i className="material-icons text-success fade-in">check_circle</i>}</header>
                                </div>
                                {admin && (
                                    <div className="card-body text-center">
                                        <LoadingSpinner loading={aLoading || tLoading} />
                                        <div>
                                            <div className="fade-in">
                                                {activeStaff.admin ? (
                                                    <>
                                                        <button
                                                            onClick={async () => {
                                                                if (window.confirm("Are sure you want make this staff an admin?")) {
                                                                    await TakeawayAdminFunc({
                                                                        variables: {
                                                                            id: ref,
                                                                        },
                                                                    });
                                                                }
                                                            }}
                                                            className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-danger"
                                                        >
                                                            Revoke Rights
                                                        </button>
                                                    </>
                                                ) : (
                                                    <button
                                                        onClick={async () => {
                                                            if (window.confirm("Are you sure you want to revoke admin rights from this staff?")) {
                                                                await MakeAdminFunc({
                                                                    variables: {
                                                                        id: ref,
                                                                    },
                                                                });
                                                            }
                                                        }}
                                                        className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success"
                                                    >
                                                        Make Admin
                                                        <i className="material-icons">arrow_right_alt</i>
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
                {activeStaff && (
                    <div className="col fade-in">
                        <div className="card" style={{ minHeight: "500px" }}>
                            <div className="card-head">
                                <header>Other Information</header>

                                {/* Staff Info Tag */}
                                <div className="tools">
                                    <NavLink
                                        to={{
                                            pathname: "/home/staffing/edit",
                                            state: { activeStaff },
                                        }}
                                        title="Update Profile"
                                        className="btn btn-color text-success fa fa-edit"
                                        onClick={() => SetInfoExpanded(!infoExpanded)}
                                    ></NavLink>
                                </div>
                            </div>
                            <div className="card-body" style={{ minHeight: "560px" }}>
                                <ul className="nav mb-3">
                                    <NavButton
                                        title="Personal Rota"
                                        icon="assignment"
                                        active={activeContent.rota}
                                        onClick={() => {
                                            SetActiveContent({ rota: true });
                                        }}
                                    />
                                    <NavButton
                                        title="Assigned Patients"
                                        icon="hotel"
                                        active={activeContent.assPatient}
                                        onClick={() => {
                                            SetActiveContent({
                                                assPatient: true,
                                            });
                                        }}
                                    />
                                    <NavButton
                                        title="Next of Kin"
                                        icon="person_outline"
                                        active={activeContent.next}
                                        onClick={() => {
                                            SetActiveContent({
                                                next: true,
                                            });
                                        }}
                                    />
                                    <NavButton
                                        title="Attachment"
                                        icon="attachment"
                                        active={activeContent.correspondents}
                                        onClick={() => {
                                            SetActiveContent({
                                                correspondents: true,
                                            });
                                        }}
                                    />
                                    {activeStaff.id === id && (
                                        <NavButton
                                            title="Annual Leave"
                                            icon="weekend"
                                            active={activeContent.leave}
                                            onClick={() => {
                                                SetActiveContent({ leave: true });
                                            }}
                                        />
                                    )}
                                </ul>

                                {activeContent.rota && (
                                    <div className="fade-in">
                                        <StaffRota location={location} staff={activeStaff} />
                                    </div>
                                )}
                                {activeContent.assPatient && (
                                    <>
                                        {activeStaff && activeStaff.patients.length > 0 && (
                                            <div className="fade-in">
                                                <PatientBasicList patients={activeStaff.patients} />
                                            </div>
                                        )}
                                        {activeStaff && activeStaff.patients.length === 0 && (
                                            <h4 className="text-danger fade-in text-center" style={{ lineHeight: "10" }}>
                                                No Patients assigned yet.
                                            </h4>
                                        )}
                                    </>
                                )}
                                {activeContent.correspondents && (
                                    <div className="fade-in">
                                        <StaffCorrespondence staff={activeStaff} />
                                    </div>
                                )}
                                {activeContent.leave && (
                                    <div className="fade-in">
                                        <StaffLeave id={ref} />
                                    </div>
                                )}
                                {activeContent.next && (
                                    <div className="fade-in">
                                        <NextOfKin location={location} item={activeStaff} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {activeStaff && admin && !activeStaff.topStaff && (
                <button
                    onClick={async () => {
                        if (window.confirm("Are you sure you want to proceed?")) {
                            await makeTopFunc({ variables: { id: ref } });
                        }
                    }}
                    title="Make Top Staff"
                    className="mdl-button fade-in fab  mdl-button--fab mdl-js-ripple-effect mdl-button--colored"
                >
                    <i className="material-icons text-white">how_to_reg</i>
                </button>
            )}
            {activeStaff && admin && activeStaff.topStaff && (
                <button
                    onClick={async () => {
                        if (window.confirm("Are you sure you want to proceed?")) {
                            await revokeTopFunc({ variables: { id: ref } });
                        }
                    }}
                    title="Revoke Top Staff"
                    className="mdl-button fade-in fab  mdl-button--fab mdl-js-ripple-effect btn-danger"
                >
                    <i className="material-icons text-white">close</i>
                </button>
            )}
        </>
    );
};

export default Profile;
